import { render, staticRenderFns } from "./caseClip_tags.vue?vue&type=template&id=23078910&scoped=true"
import script from "./caseClip_tags.vue?vue&type=script&lang=js"
export * from "./caseClip_tags.vue?vue&type=script&lang=js"
import style0 from "./caseClip_tags.vue?vue&type=style&index=0&id=23078910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23078910",
  null
  
)

export default component.exports